import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface MyAccountCustomContainerStyles {
    container?: InjectableCss;
}

export const MyAccountContainerStyles: MyAccountCustomContainerStyles = {
    container: {
        css: css`
            border: #d8d8d8 1px solid;
            background: #f7f7f7;
            color: #333333;
            padding: 40px;
            div[data-test-selector="linesContainer"] {
                > div[class^="GridOffset"] {
                    width: 100%;
                    margin: 0;
                }
            }
            div[data-test-selector="invoiceHistory_fromDateButton"] {
                display: flex;
                align-items: center;
            }

            > div[class^="Wrapper"] {
                > div[class^="GridWrapper"] {
                    > div[class^="GridOffset"] {
                        > div[class^="GridItemStyle"] {
                            > div[class^="Wrapper"] {
                                > div[data-test-selector^="cartTotal"] {
                                    ${({ theme }: { theme: BaseTheme }) =>
                                        breakpointMediaQueries(theme, [
                                            css`
                                                padding: 0px !important;
                                                margin-top: 10px;
                                            `,
                                            css`
                                                padding: 0px !important;
                                                margin-top: 10px;
                                            `,
                                            null,
                                            null,
                                            null,
                                        ])}
                                }
                            }
                        }
                    }
                }
            }

            > div[class^="Wrapper"] {
                > div[class^="GridWrapper"] {
                    > div[class^="GridOffset"] {
                        > div[class^="GridItemStyle"] {
                            > div[class^="Wrapper"] {
                                > div[class^="GridWrapper"] {
                                    > div[class^="GridOffset"] {
                                        > div:first-child {
                                            margin-bottom: 25px;
                                            > div[class^="Wrapper"] {
                                                > div[class^="GridWrapper"] {
                                                    > div[class^="GridOffset"] {
                                                        > div[class^="GridItemStyle"] {
                                                            padding-top: 8px;

                                                            > div[class^="FormFieldStyle"] {
                                                                > label {
                                                                    > a {
                                                                        > span {
                                                                            color: ${getColor("primary.main")};
                                                                        }
                                                                    }
                                                                }
                                                                > div[class^="FormInputWrapper"] {
                                                                    margin-top: 6px;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        > div:last-child {
                                            & h2 {
                                                margin-bottom: 8px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 20px;
                        `,
                        null,
                        css`
                            padding: 30px;
                        `,
                        css`
                            padding: 40px;
                        `,
                        null,
                    ],
                    "min",
                )}
        `,
    },
};

const styles = MyAccountContainerStyles;

const MyAccountCustomContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="MyAccountWrapper">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountCustomContainer,
    definition: {
        displayName: "My Account Custom Container",
        group: "My Account",
    },
};

export default widgetModule;
